import { useRef, useState } from "react";

import HeroVideo from "../assests/herovedio.mp4";
import { Volume2, VolumeX } from "lucide-react";

const Hero = () => {

  const videoRef = useRef<HTMLVideoElement>(null);

  const [muted, setMuted] = useState(true);


  const toggleSound = () => {

    if(videoRef.current){

      videoRef.current.muted = !muted;
      setMuted(!muted);

    }

  };


  return (

    <section className="w-full bg-[#F7F4EF] overflow-hidden">


      {/* VIDEO SECTION */}

      <div className="relative w-full h-[75vh] md:h-[85vh]">


        <video

          ref={videoRef}
          src={HeroVideo}
          autoPlay
          muted
          loop
          playsInline

          className="
          w-full
          h-full
          object-cover
          "
        />


        {/* Sound Button */}

      <button
  onClick={() => {
    if(videoRef.current){
      videoRef.current.muted = !muted;
      setMuted(!muted);
    }
  }}
  aria-label={muted ? "Unmute Video" : "Mute Video"}
  className="
  absolute
  bottom-5
  right-40
  z-40
  p-3.5
  bg-white/50
  backdrop-blur-md
  rounded-full
  border
  border-white/60
  text-[#1F1B18]
  hover:bg-white/80
  transition-all
  duration-300
  shadow-lg
  active:scale-95
  "
>

{muted ? (
  <VolumeX size={20} className="stroke-[1.5]" />
) : (
  <Volume2 size={20} className="stroke-[1.5]" />
)}

</button>


      </div>




      {/* CONTENT SECTION */}

      {/* <div className="
absolute
bottom-20
left-1/2
-translate-x-1/2
max-w-4xl
text-center
w-full
px-6
z-20
">


        <span className="
        uppercase
        tracking-[6px]
        text-[#1F1B18]
        text-sm
        ">

          Seoul Inspired Skincare

        </span>



        <h1
        className="
        font-heading
        text-[#1F1B18]
        text-5xl
        md:text-7xl
        leading-tight
        mt-6
        "
        >

          Skincare
          <br/>

          That
          <br/>

          Understands You


        </h1>



        <p
        className="
        text-[#1F1B18]/80
        mt-8
        text-lg
        leading-8
        max-w-xl
        mx-auto
        "
        >

          Korean-inspired skincare crafted for Indian skin.
          Experience premium beauty rituals with science-backed formulas.


        </p>



        <div className="
        flex
        justify-center
        flex-wrap
        gap-5
        mt-10
        ">


          <button

          className="
          bg-[#1F1B18]
          text-white
          border
          border-[#1F1B18]
          px-8
          py-4
          rounded-full
          font-semibold
          transition-all
          duration-500
          hover:bg-transparent
          hover:text-[#1F1B18]
          "

          >

            Shop Now

          </button>




          <button

          className="
          bg-transparent
          text-[#1F1B18]
          border
          border-[#1F1B18]
          px-8
          py-4
          rounded-full
          font-semibold
          transition-all
          duration-500
          hover:bg-[#1F1B18]
          hover:text-white
          "

          >

            Explore

          </button>


        </div>



      </div> */}





      {/* STATS SECTION */}


     <div
className="
max-w-8xl
mx-auto
px-6
pt-20
pb-16
flex
justify-center
items-center
divide-x
divide-[#1F1B18]/20
"
>


  <div className="px-10 text-center">

    <h3 className="
    text-[#1F1B18]
    text-4xl
    font-heading
    ">20K+</h3>
    <p className="text-[#1F1B18]/70 mt-2">
      Happy Customers
    </p>

  </div>

  <div className="px-10 text-center">

    <h3 className="
    text-[#1F1B18]
    text-4xl
    font-heading
    ">
      98%
    </h3>

    <p className="text-[#1F1B18]/70 mt-2">
      Positive Reviews
    </p>

  </div>



  <div className="px-10 text-center">

    <h3 className="
    text-[#1F1B18]
    text-4xl
    font-heading
    ">
      100%
    </h3>

    <p className="text-[#1F1B18]/70 mt-2">
      Clean Ingredients
    </p>

  </div>


</div>
    </section>

  );

};


export default Hero;